// import React, { useState, useEffect } from "react";
// import "./preinvoice-invoice.css";
// import axios from "axios";
// import { useParams } from "react-router";

// const additionalDocs = [
//   { id: "pre_invoice", name: "Pre-Invoice" },
//   { id: "invoice", name: "Invoice" },
// ];

// const AdditionalDocuments = () => {
//   const { claimNumber } = useParams();
//   const [availableDocs, setAvailableDocs] = useState({});

//   const azureBaseUrl = "https://caisdatahouse.blob.core.windows.net/insurance-inspection/";
//   const sasToken =
//     "sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D";

//   useEffect(() => {
//     const fetchDocuments = async () => {
//       const results = {};

//       for (const doc of additionalDocs) {
//         const blobName = `claimDocuments/${claimNumber}_${doc.id}.pdf`;

//         try {
//           const res = await axios.post("/process_data/check_document_exists", {
//             blobName,
//           });

//           if (res.data.exists) {
//             results[doc.id] = `${azureBaseUrl}${blobName}?${sasToken}`;
//           }
//         } catch (err) {
//           console.error(`Error checking document ${doc.id}:`, err.message);
//         }
//       }

//       setAvailableDocs(results);
//     };

//     fetchDocuments();
//   }, [claimNumber]);

//   const renderDocumentCard = (doc) => {
//     const fileUrl = availableDocs[doc.id];

//     return (
//       <div className="document-card" key={doc.id}>
//         <div className="text-content">
//           <p className="document-name">{doc.name}</p>
//         </div>
//         <button
//           className="action-btn preview"
//           onClick={() => window.open(fileUrl, "_blank")}
//           disabled={!fileUrl}
//         >
//           Preview
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="document-status-container-card">
//       <div className="title-container-card">
//         <h2 className="title">Documents</h2>
//         <img
//           src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
//           alt="Logo"
//           className="document-logo"
//         />
//       </div>

//       <div className="documents-grid-card">
//         {additionalDocs.map(renderDocumentCard)}
//       </div>
//     </div>
//   );
// };

// export default AdditionalDocuments;
import React, { useState, useEffect } from "react";
import "./preinvoice-invoice.css";
import axios from "axios";
import { useParams } from "react-router";


const additionalDocs = [
  { id: "pre_invoice", name: "Pre-Invoice" },
  { id: "invoice", name: "Invoice" },
];

const AdditionalDocuments = () => {
  const { claimNumber } = useParams();
  const [availableDocs, setAvailableDocs] = useState({});
  const [loading, setLoading] = useState(true);

  // ✅ Fetch documents from S3
  useEffect(() => {
    const fetchDocuments = async () => {
      const results = {};

      for (const doc of additionalDocs) {
        const blobName = `claimDocuments/${claimNumber}_${doc.id}.pdf`;

        try {
          const res = await axios.post("/process_data/check_document_exists", { blobName });

          if (res.data.exists && res.data.url) {
            results[doc.id] = res.data.url; // ✅ Use S3 signed URL returned from backend
          }
        } catch (err) {
          console.error(`Error checking document ${doc.id}:`, err.message);
        }
      }

      setAvailableDocs(results);
      setLoading(false);
    };

    fetchDocuments();
  }, [claimNumber]);

  // ✅ Renders each document card
  const renderDocumentCard = (doc) => {
    const fileUrl = availableDocs[doc.id];

    return (
      <div className="document-card" key={doc.id}>
        <div className="text-content">
          <p className="document-name">{doc.name}</p>
        </div>
        <button
          className={`action-btn preview ${!fileUrl ? "disabled" : ""}`}
          onClick={() => fileUrl && window.open(fileUrl, "_blank")}
          disabled={!fileUrl}
        >
          Preview
        </button>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="document-status-container-card loader-center">
        <p>Fetching documents...</p>
      </div>
    );
  }

  return (
    <div className="document-status-container-card">
      <div className="title-container-card">
        <h2 className="title">Documents</h2>
        <img
          src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
          alt="Logo"
          className="document-logo"
        />
      </div>

      <div className="documents-grid-card">
        {additionalDocs.map(renderDocumentCard)}
      </div>
    </div>
  );
};

export default AdditionalDocuments;
